(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/spelguide.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/spelguide.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.Spelguide = Backbone.View.extend(
    {
      tabView: undefined,
      tabViews: [],
      id: 'view-spelguide',
      idPrefix: 'tab-spelguide',
      className: 'view-spelguide',

      initialize: function() {
        if (!this.tabViews.length) {
          this.initTabs();
        }
      },

      initTabs: function() {
        var classNames = 'padding-1',
          productName = svs.tipset.models.gameDefinitions.get('productName'),
          productNameLower = productName.toLowerCase();

        this.tabViews.push({
          caption: 'Om ' + productName,
          view: new svs.tipset.views.Template({
            template:
              svs.tipset.templates['spelguide_about_' + productNameLower],
            templateName:
              'svs.tipset.templates.spelguide_about_' + productNameLower,
            className: classNames
          }),
          id: this.idPrefix + 'about'
        });

        this.tabViews.push({
          caption: 'Så här spelar du',
          view: new svs.tipset.views.Template({
            template:
              svs.tipset.templates['spelguide_howto_' + productNameLower],
            templateName: 'svs.tipset.templates.howto_' + productNameLower,
            className: classNames
          }),
          id: this.idPrefix + 'howto'
        });

        this.tabViews.push({
          caption: 'Vinstplan',
          view: new svs.tipset.views.Template({
            template:
              svs.tipset.templates['spelguide_winnings_' + productNameLower],
            templateName: 'svs.tipset.templates.winnings_' + productNameLower,
            className: classNames
          }),
          id: this.idPrefix + 'winnings'
        });
      },

      render: function() {
        var self = this;

        svs.tipset.calls.addCall('svs.tipset.views.Spelguide');

        this.$el.html(svs.tipset.templates.spelguide());
        this.renderTabs();

        this.tabView.on('onChange', function() {
          self.trigger('modalContentResize');
        });

        if (svs.tipset.data.doRenderTipsBoardAfterModal) {
          svs.tipset.data.doRenderTipsBoardAfterModal = undefined;
          svs.tipset.views.tipsboard.doHide = false;
          _.delay(function() {
            svs.tipset.views.tipsboard.render();
          }, 1000);
        }
        return this;
      },

      renderTabs: function() {
        this.tabView = new svs.components.Tabs({
          tabs: this.tabViews,
          el: this.$('#spelguide-tabview'),
          selected: this.getTabIdFromUrl(this.options.tab)
        });
      },

      getTabIdFromUrl: function(tab) {
        switch (tab) {
          case '':
            return this.idPrefix + 'about';
          case 'sa-har-spelar-du':
            return this.idPrefix + 'howto';
          case 'vinstplan':
            return this.idPrefix + 'winnings';
          default:
            return '';
        }
      },

      onDestroy: function() {
        this.$el.empty();
        this.tabView.off('onChange', function() {
          self.trigger('modalContentResize');
        });
      }
    },
    {
      type: 'svs.tipset.views.Spelguide'
    }
  );
})(Backbone, _, svs);

 })(window);